import attachValidation from '../../utils/form-validation';
import SelectorEngine from '../../utils/dom/selector-engine';

class Newsletter {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.newsletter-container');
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this._form = SelectorEngine.findOne('.newsletterForm', this._wrapper);
		const errorDismissCta = this._wrapper.querySelector('.js-dismiss-error');
		this._errorWrapper = this._wrapper.querySelector('.lta-newsletter--error');
		this.initiateValidation();

		errorDismissCta.addEventListener('click', () => {
			this._errorWrapper.classList.add('u-hidden');
		});
	}

	addManualFormValidation(form) {
		this.manualFormValidationInstance = attachValidation(form, {
			'first_name': {
				validators: {
					notEmpty: {
						message: 'Please enter your first name'
					}
				}
			},
			'last_name': {
				validators: {
					notEmpty: {
						message: 'Please enter your last name'
					}
				}
			},
			'email': {
				validators: {
					notEmpty: {
						message: 'Please enter an email address'
					},
					regexp: {
						regexp:
							// eslint-disable-next-line unicorn/better-regex, no-useless-escape
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
						message: 'Please enter a valid email address'
					}
				}
			}
		});
		
	}

	initiateValidation() {
		//const emailId = this.emailInput.name;
		this.addManualFormValidation(this._form);
		this.manualFormValidationInstance.on('core.form.valid', () => {
			this._errorWrapper.classList.add('u-hidden');
			const formAction = SelectorEngine.findOne('button[type="submit"]', this._wrapper);
			formAction.disabled = true;

			let isGoogleCaptchaValid = false;
			if (SelectorEngine.findOne('#newsletter_google_recaptcha')) {
				// eslint-disable-next-line no-undef
				const captchaResponse = grecaptcha.getResponse();
				if (captchaResponse.length > 0) {
					isGoogleCaptchaValid = true;
					// eslint-disable-next-line no-undef
					grecaptcha.reset();
				} else {
					isGoogleCaptchaValid = false;
				}
			} else {
				isGoogleCaptchaValid = true;
			}

			if (isGoogleCaptchaValid) {
				this._form.submit();
				this._form.reset();
			} else {
				const errorList = this._errorWrapper.querySelector('ul');
				errorList.textContent = 'Captcha is invalid. Please validate.';
				this._errorWrapper.classList.remove('u-hidden');
				this._errorWrapper.scrollIntoView();

				formAction.disabled = false;
			}
		});
	}
}

const newsletter = new Newsletter();
export default newsletter;
